// frontend/src/pages/DetalheEmpreendimento.jsx

import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/detalhe.css';

// Importação dos Modais
import EdicaoModal from '../components/EdicaoModal'; 
import AdicionarMarcoModal from '../components/AdicionarMarcoModal';
import FluxogramaModal from '../components/FluxogramaModal';

const API_BASE_URL = 'https://sigoapi.jhe-etes.com.br/api';

function DetalheEmpreendimento() {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('Histórico'); 
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMarcoModalOpen, setIsMarcoModalOpen] = useState(false);
  const [isFluxoModalOpen, setIsFluxoModalOpen] = useState(false);

  const fileInputRef = useRef(null);

  const fetchDetalhes = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/empreendimentos/${id}`);
      if (response.ok) {
        const result = await response.json();
        setData(result);
      }
    } catch (error) {
      console.error("Erro de conexão:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetalhes();
  }, [id]);

  if (loading) return <div className="flex h-screen items-center justify-center text-gray-400 font-medium">Carregando dados do sistema...</div>;
  if (!data) return <div className="flex h-screen items-center justify-center text-gray-500">Empreendimento não encontrado.</div>;

  const renderContent = () => {
    switch (activeTab) {
      case 'Histórico':
        const mesesMap = { 'Jan': 0, 'Fev': 1, 'Mar': 2, 'Abr': 3, 'Mai': 4, 'Jun': 5, 'Jul': 6, 'Ago': 7, 'Set': 8, 'Out': 9, 'Nov': 10, 'Dez': 11 };
        const getTimestamp = (strData) => {
            if (!strData) return 9999999999999; 
            const partes = strData.split(' '); 
            if (partes.length < 2) return 9999999999999;
            const mes = mesesMap[partes[0]] !== undefined ? mesesMap[partes[0]] : 0;
            const ano = parseInt(partes[1]);
            return (ano * 100) + mes;
        };
        const historicoOrdenado = data.historico ? [...data.historico].sort((a, b) => getTimestamp(a.data_marco) - getTimestamp(b.data_marco)) : [];

        return (
          <div className="timeline-section animate-fadeIn">
            <div className="flex justify-between items-center mb-8 px-4">
              <div>
                <h3 className="text-xl font-bold text-gray-800">Evolução da Obra</h3>
                <p className="text-gray-500 text-sm mt-1">Linha do tempo dos principais marcos do projeto</p>
              </div>
              <button onClick={() => setIsMarcoModalOpen(true)} className="px-5 py-2.5 bg-sabesp-cyan text-white rounded-full font-bold text-sm hover:bg-cyan-600 transition shadow-md hover:shadow-lg flex items-center gap-2">
                <span>+</span> Adicionar Marco
              </button>
            </div>

            <div className="timeline-scroll-area">
              <div className="flex w-max px-4">
                {historicoOrdenado.map((marco, idx) => (
                  <div key={idx} className="timeline-card-wrapper relative">
                    
                    {/* CARD DA IMAGEM */}
                    <div className="timeline-card group">
                      <div className="timeline-image-area relative bg-slate-50">
                         
                         {/* LÓGICA DA IMAGEM INTELIGENTE */}
                         {marco.imagem_url ? (
                           <>
                             <img 
                               src={marco.imagem_url} 
                               alt={marco.titulo} 
                               className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                               onError={(e) => {
                                 e.target.style.display = 'none'; // Esconde a imagem quebrada
                                 e.target.nextSibling.style.display = 'flex'; // Mostra o placeholder de erro
                               }}
                             />
                             {/* Placeholder de Erro (Oculto por padrão, aparece no onError) */}
                             <div className="hidden absolute inset-0 bg-slate-50 flex-col items-center justify-center border-b-4 border-slate-100">
                                <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center mb-2">
                                    <span className="text-2xl opacity-20 grayscale">🖼️</span>
                                </div>
                                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Imagem Indisponível</span>
                             </div>
                           </>
                         ) : (
                           /* Placeholder Padrão (Quando não tem URL) */
                           <div className="absolute inset-0 bg-gradient-to-br from-slate-50 to-slate-100 flex flex-col items-center justify-center border-b-4 border-slate-200/50">
                              <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center mb-2">
                                  <span className="text-2xl opacity-30 grayscale">📷</span>
                              </div>
                              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Aguardando Foto</span>
                           </div>
                         )}
                         
                         {/* BADGE DATA */}
                         <div className="absolute top-3 left-3 bg-white/95 backdrop-blur px-3 py-1.5 rounded-full text-xs font-bold text-sabesp-blue flex items-center gap-2 shadow-sm z-10">
                            <span>🗓️</span> {marco.data_marco}
                         </div>
                         
                         {/* BADGE STATUS */}
                         <div className={`absolute top-3 right-3 px-3 py-1.5 rounded-full text-[10px] font-bold text-white shadow-sm uppercase tracking-wide z-10 ${marco.concluido ? 'bg-emerald-500' : 'bg-violet-500'}`}>
                            {marco.concluido ? 'Concluído' : 'Previsto'}
                         </div>
                      </div>
                    </div>

                    {/* LINHA E BOLINHA */}
                    <div className="timeline-dot-wrapper">
                       {idx < historicoOrdenado.length - 1 && (<div className="timeline-connector"></div>)}
                       <div className={`timeline-dot ${marco.concluido ? 'timeline-dot-active' : 'timeline-dot-inactive'}`}></div>
                    </div>

                    {/* TEXTOS */}
                    <div className="text-center px-6">
                        <h4 className="text-gray-800 font-bold text-md mb-2">{marco.titulo}</h4>
                        <p className="text-xs text-gray-500 leading-relaxed line-clamp-3">
                           {marco.descricao}
                        </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      case 'Visão Geral':
        return (
          <div className="py-6 space-y-8 animate-fadeIn">
             <div>
                <h3 className="text-sm font-bold text-gray-400 mb-4 uppercase tracking-widest ml-1">Diferenciais do Projeto</h3>
                <div className="grid grid-cols-1 gap-4">
                    <div className="bg-sky-50/50 border border-sky-100 p-6 rounded-2xl hover:shadow-md transition-all">
                        <h4 className="font-bold text-sky-800 mb-2 flex items-center gap-2">⚡ Tecnologia Avançada</h4>
                        <p className="text-sm text-gray-600 leading-relaxed">{data.texto_tecnologia || "Sem informação."}</p>
                    </div>
                    <div className="bg-indigo-50/50 border border-indigo-100 p-6 rounded-2xl hover:shadow-md transition-all">
                        <h4 className="font-bold text-indigo-800 mb-2 flex items-center gap-2">🌱 Sustentabilidade</h4>
                        <p className="text-sm text-gray-600 leading-relaxed">{data.texto_sustentabilidade || "Sem informação."}</p>
                    </div>
                    <div className="bg-emerald-50/50 border border-emerald-100 p-6 rounded-2xl hover:shadow-md transition-all">
                        <h4 className="font-bold text-emerald-800 mb-2 flex items-center gap-2">👥 Benefícios Sociais</h4>
                        <p className="text-sm text-gray-600 leading-relaxed">{data.texto_beneficios || "Sem informação."}</p>
                    </div>
                </div>
             </div>
             
             <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100 flex justify-between items-center">
                 <div>
                    <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">Status Atual</span>
                    <p className="text-gray-800 font-medium mt-1">{data.descricao_curta}</p>
                 </div>
                 <span className="px-5 py-2 text-white font-bold rounded-lg shadow-sm uppercase tracking-wide text-xs" style={{ backgroundColor: data.cor_status || '#00AEEF' }}>
                    {data.status_atual}
                 </span>
             </div>
          </div>
        );

      case 'Engenharia':
        return (
            <div className="py-6 animate-fadeIn">
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-xl font-bold text-gray-800">Fluxograma do Processo</h3>
                    <button onClick={() => setIsFluxoModalOpen(true)} className="flex items-center gap-2 px-4 py-2 bg-white text-gray-600 rounded-lg text-sm font-medium hover:bg-gray-50 border border-gray-200 shadow-sm transition-all">
                        📤 Substituir Arquivo
                    </button>
                </div>
                <div className="bg-gray-900 rounded-2xl shadow-lg overflow-hidden group relative mb-10 border border-gray-800">
                    {data.fluxograma_url ? (
                        <div className="relative aspect-video w-full">
                            <img src={data.fluxograma_url} alt="Fluxograma" className="w-full h-full object-contain" />
                            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-sm">
                                <button onClick={() => window.open(data.fluxograma_url, '_blank')} className="bg-white text-gray-900 px-6 py-3 rounded-full font-bold shadow-xl transform translate-y-4 group-hover:translate-y-0 transition-all hover:scale-105">
                                    🔍 Visualizar em Tela Cheia
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="h-80 flex flex-col items-center justify-center text-gray-500 gap-4">
                            <span className="text-5xl opacity-20">📐</span>
                            <p>Nenhum documento técnico disponível.</p>
                            <button onClick={() => setIsFluxoModalOpen(true)} className="text-sabesp-cyan hover:underline text-sm">
                                Clique para adicionar uma imagem
                            </button>
                        </div>
                    )}
                </div>
                
                <div className="mt-8">
                    <h4 className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-4 border-b border-gray-200 pb-2">Histórico de Versões</h4>
                    {data.fluxograma_historico && data.fluxograma_historico.length > 0 ? (
                        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm">
                            <table className="min-w-full text-sm text-left">
                                <thead className="bg-gray-50 text-gray-600 font-medium">
                                    <tr>
                                        <th className="px-6 py-3">Data/Hora</th>
                                        <th className="px-6 py-3">Descrição</th>
                                        <th className="px-6 py-3">Responsável</th>
                                        <th className="px-6 py-3 text-right">Ação</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100">
                                    {data.fluxograma_historico.map((item) => (
                                        <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                                            <td className="px-6 py-4 text-gray-500">
                                                {new Date(item.data_registro).toLocaleDateString('pt-BR')} <span className="text-xs ml-1 text-gray-400">{new Date(item.data_registro).toLocaleTimeString('pt-BR', {hour: '2-digit', minute:'2-digit'})}</span>
                                            </td>
                                            <td className="px-6 py-4 font-medium text-gray-800">{item.descricao}</td>
                                            <td className="px-6 py-4 text-gray-600">
                                                <span className="bg-blue-50 text-blue-700 px-2 py-1 rounded text-xs font-bold border border-blue-100">{item.usuario}</span>
                                            </td>
                                            <td className="px-6 py-4 text-right">
                                                <a href={item.arquivo_url} target="_blank" rel="noreferrer" className="text-sabesp-cyan hover:underline font-medium text-xs uppercase tracking-wide">Visualizar</a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="text-sm text-gray-400 italic">Nenhum histórico registrado.</p>
                    )}
                </div>
            </div>
        );

      case 'Contratos':
        return (
            <div className="py-6 space-y-8 animate-fadeIn">
                <div>
                    <h3 className="contract-section-title">Contratos Atuais</h3>
                    <div className="space-y-3">
                        {data.contratos && data.contratos.filter(c => c.tipo === 'Atual').map((c) => (
                            <div key={c.id} className="contract-card contract-card-current">
                                <div className="contract-content">
                                    <h4 className="contract-title text-gray-800">{c.nome}</h4>
                                    <p className="contract-desc">{c.descricao}</p>
                                </div>
                                <span className="contract-badge bg-sabesp-cyan">{c.codigo_contrato}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div>
                    <h3 className="contract-section-title text-violet-600">Planejamento Futuro</h3>
                    <div className="space-y-3">
                        {data.contratos && data.contratos.filter(c => c.tipo === 'Futuro').map((c) => (
                            <div key={c.id} className="contract-card contract-card-future">
                                <div className="contract-content">
                                    <h4 className="contract-title text-gray-800">{c.nome}</h4>
                                    <p className="contract-desc">{c.descricao}</p>
                                </div>
                                <span className="contract-badge bg-[#312e81]">{c.codigo_contrato}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );

      default: return null;
    }
  };

  return (
    <div className="page-container relative">
      <div className="hero-header">
        <div className="hero-bg-image" style={{ backgroundImage: data.imagem_capa_url ? `url('${data.imagem_capa_url}')` : undefined }}></div>
        <div className="hero-content">
            <button onClick={() => navigate('/')} className="btn-voltar">← Voltar ao Mapa</button>
            <div className="mt-4">
                <span className="text-cyan-300 font-bold tracking-widest text-xs uppercase mb-3 block">SIGO SABESP / EMPREENDIMENTOS</span>
                <h1 className="text-3xl md:text-5xl font-bold mb-3 text-white drop-shadow-sm">{data.nome}</h1>
                <p className="text-blue-100 text-lg max-w-2xl font-light">{data.descricao_curta}</p>
                <button onClick={() => setIsModalOpen(true)} className="btn-editar-hero">⚙️ Gerenciar</button>
            </div>
        </div>
      </div>

      {/* --- CARDS FLUTUANTES (AGORA SIM, 5 COLUNAS E BORDAS COLORIDAS) --- */}
      <div className="metrics-container">
         <div className="metrics-grid grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-2">
            
            {/* 1. Vazão Atual */}
            <div className="card-metrica border-l-sabesp-cyan" style={{ borderLeftColor: '#F54927', borderLeftWidth: '4px' }}> {/* Azul */}
                <div className="card-icon-wrapper"><span className="text-2xl">💧</span><span className="card-label">Vazão Atual</span></div>
                <p className="card-value">{data.vazao_atual_ls} <span className="card-unit">L/s</span></p>
            </div>

            {/* 2. Vazão Futura */}
            <div className="card-metrica" style={{ borderLeftColor: '#60a5fa', borderLeftWidth: '4px' }}> {/* Azul */}
                <div className="card-icon-wrapper"><span className="text-2xl">📈</span><span className="card-label">Vazão Futura</span></div>
                <p className="card-value">{data.vazao_futura_ls} <span className="card-unit">L/s</span></p>
            </div>

            {/* 3. População */}
            <div className="card-metrica" style={{ borderLeftColor: '#c084fc', borderLeftWidth: '4px' }}> {/* Roxo */}
                <div className="card-icon-wrapper"><span className="text-2xl">👥</span><span className="card-label">População</span></div>
                <p className="card-value">{data.populacao_atendida?.toLocaleString()} <span className="card-unit">hab.</span></p>
            </div>

             {/* 4. Corpo Hídrico */}
             <div className="card-metrica" style={{ borderLeftColor: '#2dd4bf', borderLeftWidth: '4px' }}> {/* Teal */}
                <div className="card-icon-wrapper"><span className="text-2xl">🌊</span><span className="card-label">Corpo Hídrico</span></div>
                <p className="card-value text-xl truncate" title={data.corpo_hidrico}>{data.corpo_hidrico || "N/A"}</p>
            </div>

            {/* 5. Localização */}
            <div className="card-metrica" style={{ borderLeftColor: '#22c55e', borderLeftWidth: '4px' }}> {/* Verde */}
                <div className="card-icon-wrapper"><span className="text-2xl">📍</span><span className="card-label">Município</span></div>
                <p className="card-value text-xl truncate">{data.nome_municipio}</p>
            </div>
         </div>
      </div>

      <div className="tabs-container">
         <div className="tabs-nav">
            {['Visão Geral', 'Engenharia', 'Contratos', 'Histórico'].map((tab) => (
               <button key={tab} onClick={() => setActiveTab(tab)} className={`tab-button ${activeTab === tab ? 'tab-button-active' : 'tab-button-inactive'}`}>{tab}</button>
            ))}
         </div>
         <div className="tab-content-area">
            {renderContent()}
         </div>
      </div>

      <footer className="footer-container">
         <p>© 2025 Sabesp - Superintendência de Gestão de Empreendimentos</p>
         <div className="flex gap-4">
            <span className="hover:text-sabesp-blue cursor-pointer transition-colors">Suporte</span>
            <span className="hover:text-sabesp-blue cursor-pointer transition-colors">Documentação</span>
         </div>
      </footer>

      <EdicaoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} empreendimento={data} onUpdateSuccess={() => { fetchDetalhes(); setIsModalOpen(false); }} />
      <AdicionarMarcoModal isOpen={isMarcoModalOpen} onClose={() => setIsMarcoModalOpen(false)} empreendimentoId={data.id} onSuccess={() => { fetchDetalhes(); setIsMarcoModalOpen(false); }} />
      <FluxogramaModal isOpen={isFluxoModalOpen} onClose={() => setIsFluxoModalOpen(false)} empreendimentoId={data.id} onSuccess={() => { fetchDetalhes(); setIsFluxoModalOpen(false); }} />
    </div>
  );
}

export default DetalheEmpreendimento;